<template>
    <div class="dash">
        <div class="columns is-multiline relative">
            <div class="column is-6" v-for="(item, index) in results" :key="index">
                <div class="box hover-enlarge">
                    <div class="columns">
                        <div class="column is-4 is-flex-center">
                            <b-icon :icon="item.icon" size="is-large" :type="item.color" />
                        </div>
                        <div class="column dashboard-data">
                            <div class="title">{{ item.val | formatNumber }}</div>
                            <div class="subtitle">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <b-loading v-model="isLoading" :is-full-page="false" :can-cancel="true" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            results: [],
            isLoading: true,
            productList: [],
        };
    },
    async mounted() {
        try {
            let tmp = await this.$http.get('/dashboard');
            this.results = tmp.data;
        } catch (err) {
            this.$buefy.toast.open({
                duration: 5000,
                message: "Something went wrong.",
                position: "is-bottom",
                type: "is-danger",
            });
        }

        this.isLoading = false
    },
};
</script>

<style>
.is-flex-center {
    display: flex !important;
    justify-content: center;
    align-items: center;
}
.dashboard-data {
    text-align: end;
}
.hover-enlarge .icon {
    transition: all 300ms;
}
.hover-enlarge:hover .icon {
    transform: scale(1.4);
}
.hover-enlarge {
    transition: all 300ms;
}
.hover-enlarge:hover {
    transform: scale(1.01);
}
.dash {
    min-height: 100px;
}
</style>